export default __webpack_public_path__ + "static/delay-pro-bg-a75a72462cfdbd5bc4c5e1dff2b680b8.png";